var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquares(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 250,
    viewBox: "0 0 216 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 71H0V143H72V119.99C65.3282 119.728 60 114.236 60 107.5C60 100.764 65.3282 95.2723 72 95.0098V71Z",
    fill: "#00BED5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 143H216V71L144 71V95.0098C150.672 95.2723 156 100.764 156 107.5C156 114.236 150.672 119.728 144 119.99V143Z",
    fill: "#F5B700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.149 249.765L178.083 220.839L149.157 154.905L127.17 164.551C127.109 164.396 127.045 164.242 126.978 164.089C124.204 157.767 116.831 154.89 110.509 157.664C104.187 160.437 101.31 167.811 104.084 174.133C104.151 174.286 104.221 174.437 104.294 174.586L83.2226 183.831L112.149 249.765Z",
    fill: "#00BED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 71.5C120 78.4036 114.404 84 107.5 84C100.596 84 95 78.4036 95 71.5C95 71.3439 95.0029 71.1885 95.0085 71.0338L72.1063 71L72.0708 95.0263C65.3829 95.2616 60.0285 100.753 60.0186 107.5C60.0086 114.247 65.3467 119.754 72.0339 120.009L72 143L95.0112 143.034C95.0038 142.857 95 142.679 95 142.5C95 135.596 100.596 130 107.5 130C114.404 130 120 135.596 120 142.5C120 142.691 119.996 142.882 119.987 143.071L144 143.106L144.034 120.009C150.707 119.758 156.044 114.273 156.054 107.537C156.064 100.8 150.743 95.3006 144.071 95.029L144.106 71.1064L119.993 71.0707C119.998 71.2132 120 71.3563 120 71.5Z",
    fill: "#002677"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144 0H72V72H95.0098C95.0033 72.1659 95 72.3325 95 72.5C95 79.4036 100.596 85 107.5 85C114.404 85 120 79.4036 120 72.5C120 72.3325 119.997 72.1659 119.99 72H144V0Z",
    fill: "#FF681F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.e84e692c3b4bebb23ad0408cfe5e1f22.svg";
export { ForwardRef as ReactComponent };